import type { DueRule } from '@mfos/shared';
import { formatDate } from '../../lib/format';

export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

/** Human description of a structured due rule; times are in the workspace time zone. */
export function describeDueRule(rule: DueRule): string {
  switch (rule.kind) {
    case 'DAILY':
      return `Every day at ${rule.time}`;
    case 'WEEKLY':
      return `Every ${WEEKDAYS[rule.weekday - 1] ?? `weekday ${String(rule.weekday)}`} at ${rule.time}`;
    case 'MONTHLY':
      return rule.day === 'LAST'
        ? `Last day of each month at ${rule.time}`
        : `Day ${String(rule.day)} of each month at ${rule.time}`;
    case 'QUARTERLY':
      return `Last day of each quarter at ${rule.time}`;
    case 'ONE_TIME':
      return `Once, on ${formatDate(rule.date)} at ${rule.time}`;
  }
}
